import React from 'react';
import { Prospect } from '../../shared/types';
import { Card } from '../../components/ui/Card';
import { Calendar, CheckCircle2 } from 'lucide-react';

interface TimelineSectionProps {
  prospect: Prospect;
}

export const TimelineSection: React.FC<TimelineSectionProps> = ({ prospect }) => {
  const weeks = [
    {
      week: 'Semana 1',
      title: 'Diagnóstico & Estrutura',
      tasks: [
        'Alinhamento de acessos e fontes de informação da marca',
        'Modelagem do catálogo inicial de produtos no D1',
        'Definição dos tokens do Design System Turquesa',
      ],
    },
    {
      week: 'Semana 2',
      title: 'Identidade Digital & Conexões',
      tasks: [
        'Implementação da Loja Virtual e Biolink Comercial',
        'Revisão completa do Perfil da Empresa no Google',
        'Configuração do Google Merchant Center e Meta Catalog',
      ],
    },
    {
      week: 'Semana 3',
      title: 'Integrações & Testes de Checkout',
      tasks: [
        'Testes de fluxo de compra no WhatsApp e checkout',
        'Configuração de Pixel da Meta e Google Analytics',
        'Setup das primeiras campanhas de tráfego pago',
      ],
    },
    {
      week: 'Semana 4',
      title: 'Lançamento & Relatório Inicial',
      tasks: [
        'Abertura oficial do canal próprio de vendas',
        'Ativação das campanhas de lançamento e remarketing',
        'Reunião de entrega e apresentação do primeiro relatório',
      ],
    },
  ];

  return (
    <section className="py-16 border-b border-slate-100 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-xs font-bold uppercase tracking-wider text-[var(--ym-prospect-primary)]">
            Implantação Ágil
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mt-2">
            Cronograma Estimado de Lançamento (4 Semanas)
          </h2>
          <p className="text-slate-600 mt-3 text-sm md:text-base">
            Um plano passo a passo organizado para colocar o ecossistema da {prospect.trade_name} em funcionamento com total controle.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {weeks.map((w, idx) => (
            <Card key={idx} className="border-slate-200 bg-white shadow-sm p-5 flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3 pb-2 border-b border-slate-100">
                  <span className="text-xs font-extrabold text-[var(--ym-prospect-primary)] uppercase tracking-wider">
                    {w.week}
                  </span>
                  <Calendar className="w-4 h-4 text-slate-400" />
                </div>
                <h3 className="font-bold text-slate-900 text-base mb-3 leading-snug">{w.title}</h3>
                <ul className="space-y-2 text-xs text-slate-600">
                  {w.tasks.map((task, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0 mt-0.5" />
                      <span>{task}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
